<template>
    <Fragment>
        <VueScene ref="scene_about_hide" :keyframes="keyframes_hide" :autoplay=false>
            <span></span>
        </VueScene>
        <VueScene ref="scene_about_show" :keyframes="keyframes_show" :autoplay=false>
            <span></span>
        </VueScene>
        <div class="aboutoverlay" id="aboutoverlay" style="display: block">
            <div class="aboutcontent" id="aboutcontent">
                <span></span>
                <button class="closebutton" @click="$emit('close-about')"><i class="fal fa-times"></i></button>
                <div class="tabs">
                    <div @click="page='about'" :class="'tab' + (page==='about'?' active':'')">about</div>
                    <div @click="page='credits'" :class="'tab' + (page==='credits'?' active':'')">credits</div>
                    <div @click="page='background'" :class="'tab' + (page==='background'?' active':'')">background</div>
                </div>
                <div class="content" v-if="page=='about'">
<!--                    <h1>About these bones, this flesh, this skin</h1>-->
                    <p class="intro">
                        Suddenly we see so much in our daily landscape: the light, the textures, nature sneaking through
                        the cracks… We can also notice a different sense of time, or rather different times co-existing
                        in and around us.
                    </p>
                    <p>
                        Developed in collaboration between Scottish Ensemble and Scottish Dance Theatre, <i>these bones,
                        this flesh, this skin</i> is a digital work for solo violin and solo dancer by composer Martin
                        Suckling, choreographer Joan Clevillé and cinematographer Genevieve Reeves. Through a bespoke
                        online platform, the audience is invited to combine different audio and visual layers to decide
                        how they want to experience the work in multiple iterations.
                    </p>
                    <p>
                        Born out of a unique period in our lives, the piece explores how heightened attention can reveal
                        different experiences of time in our bodies and the environment around us. This layering of
                        simplicity and complexity also manifests in the way that the viewer / listener is invited to
                        make decisions. With every new iteration we discover new perspectives, new nuances waiting for
                        us in the spaces in between music, cinematography and dance, between the traces of our own
                        memories and the aliveness of our attention.
                    </p>
                </div>
                <div class="content" v-if="page=='credits'">
<!--                    <h1>Credits</h1>-->
                    <p>
                        Commissioned by Scottish Ensemble and Scottish Dance Theatre <br />
                        Composer: <a target="_blank" href="http://www.martinsuckling.com/">Martin Suckling</a><br />
                        Choreography: <a target="_blank" href="https://www.scottishdancetheatre.com/company/team/joan-clevill">Joan Clevillé</a> <br />
                        Cinematography: <a target="_blank" href="https://www.scottishdancetheatre.com/company/collaborators/genevieve-reeves">Genevieve Reeves</a> <br />
                        Performance: <a target="_blank" href="https://scottishensemble.co.uk/musician/jonathan-morton/">Jonathan Morton (violin)</a>,
                        <a target="_blank" href="https://www.scottishdancetheatre.com/company/dancers/joo-castro">João Castro (dance)</a> <br />
                        Costume Advice: Matthias Strahm<br />
                        Sound Engineering: Jonathan Green <br />
                        Digital Design: <a target="_blank" href="https://boundary.io/">Ronan McMacken</a> <br />
                        Software Development: <a target="_blank" href="https://kup.io/sen">Ian Beveridge</a> <br />
                        Interim Production Manager, Scottish Dance Theatre: Adam McCall<br />
                        Producer, Scottish Ensemble: Stuart Burns
                    </p>
                    <p>
                        <img class="creditlogo" style="width: 152px;max-width: 27%; height: auto" height="100" src="../assets/Creative_Scotland_bw.png" />
                        <img class="creditlogo" style="width: 140px;max-width: 25%; height: auto" height="100" src="../assets/dundee-council.png" />
                        <img class="creditlogo" style="width: 89px;max-width: 16%; height: auto" height="100" src="../assets/Dundee-Rep-Logo.png" />
                        <img class="creditlogo" style="width: 58px;max-width: 10%; height: auto" height="100" src="../assets/glasgow-council.png" />
                    </p>

                    <p><strong>Composition, Martin Suckling</strong></p>

                    <p>Martin Suckling is a composer and violinist. His music has been championed by many leading
                        orchestras and ensembles including the London Symphony Orchestra, Scottish Ensemble, London
                        Sinfonietta, BBC Philharmonic, BBC Scottish Symphony Orchestra, Deutsches Symphonie-Orchester
                        Berlin, and the London Contemporary Orchestra.</p>

                    <p>From 2013-18 Suckling was the Scottish Chamber Orchestra’s Associate Composer, a partnership
                        which resulted in Six Speechless Songs (premiered by Robin Ticciati and later revived by Oliver
                        Knussen), a concerto for pianist Tom Poster, and Meditation (after Donne) for chamber orchestra
                        and electronics. Other orchestral works include Release, premiered at the 2013 Tectonics
                        festival by Ilan Volkov and the BBC Scottish Symphony Orchestra, and The White Road, a flute
                        concerto for Katherine Bryan and the Royal Scottish National Orchestra premiered in 2017. His
                        song cycle The Tuning to texts by Michael Donaghy recently won a Scottish Award for New Music. A
                        portrait disc of orchestral music on the NMC label will be released in 2021 featuring studio
                        recordings of his concertos for flute and piano, with Katherine Bryan and Tamara Stefanovich as
                        soloists. Martin is published by Faber Music, and has recently been promoted to Professor of
                        Music at the University of York.</p>

                    <p><strong>Choreography, Joan Clevillé</strong></p>

                    <p>Joan Clevillé is a dancer and choreographer and, since April 2019, the Artistic Director of
                        Scottish Dance Theatre. Born in Barcelona, he combined his dance training at Elise Lummis’ La
                        Companyia with studies in Humanities at University Pompeu Fabra. He worked internationally as a
                        dancer and rehearsal director for seventeen years in companies across Europe, including Scottish
                        Dance Theatre, Collective Endeavours, Lost Dog, Dog Kennel Hill Project, the Ballet of the Graz
                        Opera, the Choreographic Centre of Valencia and Ballet Carmen Roche.</p>

                    <p>In 2015, he created his own independent company, Joan Clevillé Dance, presenting his work
                        extensively across the UK and mainland Europe. Joan has also received international commissions
                        as a choreographer and movement director and worked regularly as a guest teacher in companies
                        and conservatoires in Sweden, the UK, Catalonia and The Netherlands. His choreographic practice
                        is rooted both in movement research and experimentation with theatre and storytelling. Exploring
                        the connections between breath, voice and movement, his works invite audiences to engage with
                        their senses, intellect and imagination, and explore subjects connected to our contemporary
                        reality and the notion of change.</p>

                    <p><strong>Cinematography, Genevieve Reeves</strong></p>

                    <p>Genevieve is a multidisciplinary artist who began studying dance, photography and film whilst
                        based in Oxford. Her passion for combining these worlds found her quickly immersed in the
                        digital dance landscape, working with companies such as Avante Garde, Dance Adventures and
                        Scottish Dance Theatre as a photographer, cinematographer and editor.</p>

                    <p>As a dancer, Genevieve has toured works choreographed by Ben Duke and Theo Clinkard and was
                        selected to perform “Wilderness” choreographed by Tony Adigun for the Robin Cohan at 90
                        showcase. Genevieve performed “Dark Flares” by Humanhood and “The Great Shebang” by Vinnicius
                        Salles whilst training at NSCD. Since graduating she has performed and toured “The Circle”,
                        “Looping: Scotland Overdub”, “Storage for Future Sunsets”, “Locus” and her own choreographic
                        work under the umbrella of Scottish Dance Theatre. During these projects, she has continued to
                        expand her photographic portfolio exploring representations of the dancers’ body; her series
                        “Solo I” was exhibited at Sputnik 2020. Since the COVID19 pandemic, she has launched the
                        instagram platform @covid.dance, promoting dancers and supporting the arts community on an
                        international scale.</p>

                    <p><strong>Performance, João Castro</strong></p>

                    <p>João Castro started his professional dance training at CEFAR (Center for Artistic Training -
                        Palacio das Artes) in Belo Horizonte, Brazil in 2011. In that same year, he joined Ballet Jovem
                        Palacio das Artes, under the artistic direction of Andrea Maia (Balé da Cidade de São Paulo).
                    </p>

                    <p>In 2013, he participated in “Viva, Vive!”, a collaboration between Ballet Jovem and Black Box
                        Dance Company under the direction of Marie Brolin-Tani in Holstebro, Denmark. With "Viva, Vive!"
                        he embarked on a tour around Denmark and Sweden in the following year. Castro joined Baltic
                        Dance Theatre in October 2014 in Gdansk, Poland where he had the opportunity to work with Jiří
                        Kylián and Patrick Delcroix. In March 2016, he joined ZfinMalta Dance Ensemble in Malta. There
                        he performed works by various choreographers, such as José Agudo and Iván Pérez. Before joining
                        Scottish Dance Theatre in March 2020, Castro performed in Matthew Bourne's Swan Lake (UK and
                        International tour), including Sadler's Wells season and a special performance at the Olivier
                        Awards 2019.</p>

                    <p><strong>Performance, Jonathan Morton</strong></p>

                    <p>Jonathan Morton is a musician equally at home in old and new music who enjoys collaborating with
                        musicians and artists from different traditions. </p>

                    <p>He is Artistic Director at Scottish Ensemble, where his eclectic and engaging programming has
                        been enthusiastically praised by audiences internationally, offering fresh perspectives on
                        familiar repertoire and championing new works. Under his leadership Scottish Ensemble has been
                        collaborating increasingly with other art forms such as dance, visual arts and theatre. Recent
                        critically-acclaimed projects include 20th Century Perspectives with artist Toby Paterson,
                        Goldberg Variations – ternary patterns for insomnia with Andersson Dance, and Anno with Anna
                        Meredith and Eleanor Meredith. Jonathan is also Principal First Violin at London Sinfonietta,
                        where he has been given the opportunity to work closely with many of today’s leading composers
                        and performers, including Steve Reich, Harrison Birtwhistle, Mica Levi, Oliver Knussen, Marius
                        Nesset, Jonny Greenwood, Louis Andriessen, Thurston Moore, John Woolrich, Martin Suckling and
                        Tyondai Braxton.</p>

                    <p><strong>Costume Advice, Matthias Strahm</strong></p>

                    <p>Originally from Switzerland, Matthias Strahm is a costume and set designer based in Scotland.
                        Whilst working as a professional dancer in companies across Europe, he developed an interest
                        in design for live performance, gathering initial experiences as a visiting student at the
                        University of the Arts in Graz, Austria and as assistant designer at the Graz Opera and
                        Schauspielhaus Graz. Since 2012, he has worked as a freelance designer for Theatre, Dance,
                        Musical and Operetta in the UK, Germany and Austria. His credits include costume and / or set
                        designs for Scottish Dance Theatre, Joan Clevillé Dance, Janis Claxton Dance, Theater Paderborn,
                        Schauspielhaus Graz, Stadttheater Baden-Baden and Stadttheater Ingolstadt amongst others.</p>

                    <p><strong>Sound Engineering, Jonathan Green</strong></p>

                    <p>Jonathan Green graduated with a first-class degree in classical composition from Birmingham
                        Conservatoire in 2005. His music has been performed around the UK and Europe and has been
                        featured on BBC Radio 3. As a sound designer and mix engineer specialising in classical music,
                        he has worked around the world with many leading artists and ensembles. He enjoys performing
                        challenging live electronic music and works with publishers and composers to realise existing
                        live electronic music that relies on obsolete technology.</p>

                </div>
                <div class="content" v-if="page=='background'">
<!--                    <h1>Background</h1>-->
                    <p class="intro">
                        Scottish Dance Theatre, Scottish Ensemble and composer Martin Suckling reflect on their new
                        collaboration
                    </p>

                    <p><strong>Jonathan Morton</strong></p>

                    <p>The initial idea was relatively simple - in the absence of live performance, could we create a
                        short collaborative project designed to be experienced online? As soon as we started discussing
                        ideas with Joan and Martin during those early lockdown Zoom calls, I was thrilled by the scope
                        of the conversations and the shared ambition to find a common artistic impulse that would bind
                        us throughout the making of the project. The team quickly grew, with Genevieve, João, sound
                        engineer Jonathan Green and digital designer Ronan McMacken all making highly distinctive and
                        beautiful layers of contributions.</p>

                    <p>Although we were unable to meet each other face to face, we developed a kind of creative
                        camaraderie which allowed the piece to grow in ambition and depth. So much material was shared
                        in this virtual studio: music and dance sketches, drawings, photos, improvisations, musings and
                        thoughts, technical diagrams… I think we developed our own way of working together, adapting and
                        responding to the circumstances. It has been a privilege to take part in it.</p>

                    <p><strong>Martin Suckling</strong></p>

                    <p>I wanted to be certain we produced something which wasn’t simply a filmed version of a live
                        performance but rather something which was made to be experienced online and took advantage of
                        the possibilities this opens up. Something which allows the audience to participate in the
                        experience, something which would not be possible ‘in real life’.</p>

                    <p>Several themes emerged from our discussions around life in lockdown: how we were noticing things
                        differently, familiar things taking on strange new features; while our geographical scope
                        narrowed, the detail of it expanded to fill the gap; subtle variations on routines and repeated
                        journeys becoming rich with significance; across it all a sense of in-betweenness, a
                        provisionality to everything, a waiting...</p>

                    <p>In the same way, there is no definitive version of this piece. The various possible combinations
                        of layers allow you to experience a single journey from different visual and aural perspectives.
                        The music was written alongside the dance and filmography rather than prior to it: we found a
                        shared vocabulary and sent each other snippets of music, film and dance to work from; I
                        improvised violin lines to rehearsal footage and reshaped structures to respond to the rhythms
                        of draft cuts of the film. In one layer, the music is slowed down to 1/8th speed to bring out
                        the detail of a bow stroke’s ‘extraneous’ noises, but that is the extent of the processing:
                        Jonathan’s violin provides all the sonic material.</p>

                    <p><strong>Joan Clevillé</strong></p>

                    <p>At the start of the process, we talked as a creative team about how slowing down during lockdown
                        had heightened our awareness and how our attention had turned towards ourselves and the
                        environment around us. As a choreographer, I became interested in developing choreographic
                        tools that would help the dancer to direct his attention in different ways. Working in separate
                        rooms and with the help of videoconferencing, we discovered that by bringing our awareness
                        towards different components of our bodies, we were able not only to generate a rich palette of
                        movement, but also to reveal a complex array of ways of experiencing time.</p>

                    <p>This layering of simplicity and complexity has remained present throughout the process, and it
                        also manifests in the way that the viewer / listener is invited to make decisions about how
                        they want to experience the work. With every new iteration we discover new perspectives, new
                        nuances waiting for us in the spaces in between music, cinematography and dance, between the
                        traces of our own memories and the aliveness of our attention.</p>

                    <p><strong>João Castro</strong></p>

                    <p>This is a time of silence, of listening closely, slowing down and paying attention. The 'in
                        between' state that lockdown forced us all into created the need and the space for different
                        ways of connecting. And that feeling permeated the entire process of making this film. The
                        project in and of itself is meant for connecting people, to bring closer attention to detail, to
                        our surroundings, to sounds, music, movement. Creating this piece of work felt like a direct
                        response to the world around us ‘shutting down’ and with every stage of the process came the
                        realisation that even when nothing happens there’s still movement, there’s still music, there’s
                        still life.</p>

                    <p><strong>Genevieve Reeves</strong></p>

                    <p>From the get go I was excited to see what array of ideas would come from a group of individuals
                        with such a broad range of creative backgrounds. Needless to say the artistry and imagination
                        created in our Zoom bubble was inspiring. Because of these virtual conversations and practices
                        (around the beauty and persistence of nature, time and the varying speeds of life in different
                        materials) we managed to create a collective mind, giving me such clarity of vision going into
                        the filming process. </p>

                    <p>Being involved in the movement practise with Joan and João allowed me to understand what they
                        were working with from the inside out; a perception that was integral to the success of the
                        footage. Joan was not only an artistic guide and voice of reason, but also a steady hand to hold
                        an umbrella in Scottish springtime! Combining the films with the music from Martin and Jonathan
                        has been such a pleasure - you can sense that both medias have been birthed from the same series
                        of discussions. I hope that we have created something that also gives the viewer the authority
                        to make decisions and be part of the process. For me the way that this work has come about is
                        just as important as the final product. We reflect this by allowing the user to curate their own
                        experience.</p>

                    <p><strong>About Solo Collaborations</strong></p>

                    <p><i>these bones, this flesh, this skin</i> is the first in a series of Solo Collaborations, online
                        audiovisual works capturing Scottish Ensemble’s approach to imaginative cross-artform
                        collaborations.</p>

                    <p>The heart of each Solo Collaboration is the creation of a new commission: a work of around four
                        minutes created in partnership between a composer, a collaborator from another artform and a
                        member of Scottish Ensemble. Working closely throughout the process, the composer will create a
                        new work, recorded by the musician at home, while the collaborator creates a filmed visual
                        response. Our aim is for each Solo Collaboration to be the starting point for a longer term
                        partnership, ideally leading to live interaction between artists in the future.</p>

                </div>
            </div>
        </div>
    </Fragment>
</template>

<script>

    import { VueScene } from "vue-scenejs";
    import { Fragment } from 'vue-fragment'

    export default {
        name: 'AboutOverlay',
        components:{
            VueScene,
            Fragment
        },
        props:{
            show: Boolean
        },
        watch: {
            // eslint-disable-next-line no-unused-vars
            show: function(newVal, oldVal) {
                if(newVal){
                    this.$refs.scene_about_show.play();
                } else{
                    this.$refs.scene_about_hide.play();
                }
            }
        },
        data() {
            return {
                page: "about",
                "keyframes_show": {
                    // eslint-disable-next-line no-unused-vars
                    "#aboutcontent": i => ({
                        0: {
                            "padding-top": "80px"
                        },
                        0.5: {
                            "padding-top": "30px"
                        },
                        easing: "linear"
                    }),
                    // eslint-disable-next-line no-unused-vars
                    "#aboutoverlay": i => ({
                        0: {
                            "display": "none",
                            "opacity": 0
                        },
                        0.05: {
                            "display": "block",
                            "opacity": 0
                        },
                        0.5: {
                            "display": "block",
                            "opacity": 1
                        }
                    })
                },
                "keyframes_hide": {
                    // eslint-disable-next-line no-unused-vars
                    "#aboutcontent": i => ({
                        0: {
                            "padding-top": "30px"
                        },
                        0.5: {
                            "padding-top": "80px"
                        },
                        easing: "linear"
                    }),
                    // eslint-disable-next-line no-unused-vars
                    "#aboutoverlay": i => ({
                        0: {
                            "display": "block",
                            "opacity": 1
                        },
                        0.45: {
                            "display": "block",
                            "opacity": 0
                        },
                        0.5: {
                            "display": "none",
                            "opacity": 0
                        }
                    })
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    @import "../assets/styles/variables";

    .aboutoverlay{
        position: absolute;
        top:0;
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(69, 69, 69, 0.324) 100%), rgba(0, 0, 0, 0.9);

        .aboutcontent{
            width: 780px;
            color:white;
            margin: 0 auto;
            height: calc(100% - 150px);
            max-width: 90%;
            position: relative;

            /* mobile */
            @media only screen and (max-width : 736px) {
                width: 80%;
            }

            .content {
                overflow-y: scroll;
                height: 100%;
                -ms-overflow-style: none;  /* IE and Edge */
                scrollbar-width: none;  /* Firefox */
                margin-top: 20px;

                a {
                    color: white;
                }

                &::-webkit-scrollbar {
                    display: none;
                }

                .creditlogo:not(:first-child) {
                    margin-left: 13px;
                }

                h1 {
                    font-family: Cormorant Garamond;
                    font-style: normal;
                    font-weight: 500;
                    font-size: 40px;
                    line-height: 55px;

                    color: #FFFFFF;

                    text-shadow: 0px 10px 30px rgba(0, 0, 0, 0.6);                }
                p {
                    font-family: Lato;
                    font-style: normal;
                    font-weight: 300;
                    font-size: 16px;
                    line-height: 22px;

                    letter-spacing: 0.04em;

                    color: #FFFFFF;
                    margin-bottom: 30px;
                    &.intro {
                        font-family: Cormorant Garamond;
                        font-style: italic;
                        font-weight: 500;
                        font-size: 23px;
                        line-height: 29px;

                        text-shadow: 0px 10px 30px rgba(0, 0, 0, 0.6);                    }
                }
            }

            .closebutton {
                color: #d2d2d2;
                border: 1px solid #d2d2d2;
                width: 50px;
                height: 50px;
                border-radius: 100px;
                background-color: transparent;
                float: right;
                margin-top: -8px;
                cursor: pointer;
                position: absolute;
                right: 20px;

                &:hover {
                    color: #fff;
                    border: 1px solid #fff;
                }
            }

            .tabs {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: flex-start;
                align-content: stretch;
                clear: both;

                .tab {
                    flex: 0 1 auto;
                    align-self: auto;
                    margin-left: 20px;

                    font-family: Lato;
                    font-style: normal;
                    font-weight: 300;
                    font-size: 16px;
                    line-height: 19px;

                    padding-bottom: 10px;

                    color: #D2D2D2;

                    cursor: pointer;
                    border-bottom: 1px solid transparent;

                    &.active {
                        border-bottom: 1px solid #d2d2d2;
                        color: white;
                    }

                    &:hover {
                        color: white;
                    }

                    &:nth-child(1) {
                        margin-left: 0;
                    }
                }
            }
        }
    }

</style>
